import React from "react";
import AppContent from "./AppContent";
import { AppStoreProvider } from "./store";
import { toast, Slide } from "react-toastify";
import TealiumHandler from "./TealiumHandler";
import { AlertMessageProvider } from "./contexts";

toast.configure({
  transition: Slide,
});

export const App: React.FunctionComponent = () => {
  return (
    <AppStoreProvider>
      <TealiumHandler>
        <AlertMessageProvider>
          <AppContent />
        </AlertMessageProvider>
      </TealiumHandler>
    </AppStoreProvider>
  );
};

export default App;
